import React from 'react';

class Statement extends React.Component {
  render() {
    return (

      <div className="statement-padding text-align-center">
        <h10 is="custom">Help us become the go to site for football stats</h10>
        <p5 is="custom">Post about us on your socials to build our community and spread the word about StatHero.</p5>
      </div>
    )
  }
}
export default Statement;
